import { Radar } from "react-chartjs-2"
import styled from "styled-components"
import mixins from "../../../styles/mixins"
import { useEffect, useState } from "react";

const Wrap = styled.article`
    position: relative;
    flex: 1 1;

    > .h2 {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .chart-label {
        display: flex;
        align-items: center;
        gap: 0 6px;
        ${mixins.body3};
        &::before {
            content: "";
            display: block;
            border-radius: 100%;
            width: 8px;
            height: 8px;
            border: 1px solid rgba(28, 195, 145, 1);
            background-color: rgba(28, 195, 145, 0.2);
        }
    }
    canvas {
        align-self: center;
    }
`
export default function SkinTrouble({data}) {
    const [label, setLabel] = useState([]);
    const [score, setScore] = useState([]);
    useEffect(() => {
        const labelArr = [];
        const scoreArr = [];
        
        for (const key in data) {
                let name = "";
                const scoreData = data[key]['score'];
                switch (key) {
                    case "skin_glow":
                        name = "광채";
                        break;
                    case "pore":
                        name = "모공";
                        break;
                    case "blackhead":
                        name = "블랙헤드";
                        break;
                    case "speckle":
                        name = "홍조";
                        break;
                    case "black_rim_of_eye":
                        name = "다크서클";
                        break;
                    case "acne":
                        name = "포르피린";
                        break;
                }
                if (scoreData) {
                    labelArr.push(name);
                    scoreArr.push(scoreData);
                }
        }

        setLabel(labelArr);
        setScore(scoreArr);
    },[]);
    return (
    <Wrap className="skin-trouble">
        <div className="h2">
            피부트러블
            <span className="chart-label">얼굴 지수</span>
        </div>

        <Radar
            width={252}
            height={223}
            options={{
                responsive: false,
                animation: {
                    duration: 0,
                },
                scales: {
                    r: {
                        ticks: {
                            stepSize: 20,
                            display: false,
                            font: {
                                family: "Pretendard",
                            },
                        },
                        grid: {
                            circular: true,
                        },
                        //라벨 속성 지정.
                        pointLabels: {
                            font: {
                                family: "Pretendard",
                                size: 12,
                                weight: "400",
                            },
                            color: "#000",
                        },
                        suggestedMin: 0,
                        suggestedMax: 10,
                    },
                },
                plugins: {
                    datalabels: {
                        display: false
                    },
                    legend: {
                        display: false,
                    },
                },
            }}
            data={{
                labels: label,
                datasets: [
                    {
                        label: "얼굴 지수",
                        data: score,
                        backgroundColor: "rgba(28, 195, 145, 0.1)",
                        borderColor: "rgba(28, 195, 145, 1)",
                        borderWidth: 1,
                        radius: 0,
                        pointBackgroundColor: "rgb(255, 99, 132)",
                        pointBorderColor: "#fff",
                        pointBackgroundColor: "rgba(28, 195, 145, 0.2)",
                        pointBorderColor: "rgba(28, 195, 145, 1)",
                    },
                    {
                        // 스타일(포인트)을 위한 데이터
                        label: "",
                        data: [100, 100, 100, 100, 100, 100], // 실제 데이터중 가장 큰 값
                        backgroundColor: "rgba(28, 195, 145, 0)",
                        borderColor: "rgba(28, 195, 145, 1)",
                        borderWidth: 0,
                        pointBackgroundColor: "rgb(255, 99, 132)",
                        pointBorderColor: "#fff",
                        pointBackgroundColor: "rgba(205, 205, 205, 1)",
                        pointBorderColor: "rgba(205, 205, 205, 1)",
                        radius: 2,
                    },
                ],
            }}
        />
    </Wrap>
    )
}